import * as React from 'react'

import { Box, Icon, SelectListItem } from '@factorialco/deprecated-design-system'
import moment from 'moment'

import ScrollableList from 'modules/core/components/ScrollableList'

export interface Props {
  setSelectedWeekday: (weekday: number) => void
  selectedWeekday: number | undefined
}

export default function WeeklySelect({ selectedWeekday, setSelectedWeekday }: Props) {
  const weekdays = Array.from(Array(7), (_, i) => {
    return moment()
      .isoWeekday(i + 1)
      .format('dddd')
  })

  const renderIllustration = () => {
    return (
      <div>
        <Icon.Medium icon="play" />
      </div>
    )
  }

  return (
    <ScrollableList size="medium">
      <Box gap="s8">
        {weekdays.map((day, index) => (
          <Box key={index}>
            <SelectListItem
              key={index}
              label={day}
              disabled={false}
              illustration={renderIllustration}
              onClick={() => setSelectedWeekday(index)}
              selected={index === selectedWeekday}
            />
          </Box>
        ))}
      </Box>
    </ScrollableList>
  )
}
